import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';

export const collectEntryGuidsFromRow = row => {
  const entries = row?.NotaryEntries || [];
  if (entries.length > 0) {
    return entries.map(entry => entry?.GUID).filter(Boolean);
  }
  return row?.GUID ? [row.GUID] : [];
};

export const collectEntryGuidsFromSelection = (selectedRowIds, page) => {
  const guids = [];
  Object.keys(selectedRowIds || {}).forEach(idx => {
    const row = page?.[parseInt(idx, 10)];
    const original = row?.original;
    if (!original) return;

    const entries = original.NotaryEntries || [];
    if (entries.length > 0) {
      entries.forEach(entry => {
        if (entry?.GUID) guids.push(entry.GUID);
      });
    } else if (original.GUID) {
      guids.push(original.GUID);
    }
  });
  return [...new Set(guids)];
};

const JournalBulkActions = ({
  table,
  selectedRowIds,
  page,
  onShareClick,
  disabled
}) => {
  if (!table) return null;

  const selectedCount = Object.keys(selectedRowIds || {}).length;
  if (selectedCount === 0) return null;

  const entryGuids = collectEntryGuidsFromSelection(selectedRowIds, page);

  return (
    <div className="d-flex align-items-center gap-2 mb-3">
      <span className="text-600 fs--1">
        {selectedCount} row{selectedCount === 1 ? '' : 's'} selected
        {entryGuids.length > 0
          ? ` (${entryGuids.length} entr${
              entryGuids.length === 1 ? 'y' : 'ies'
            })`
          : ''}
      </span>
      <Button
        variant="primary"
        size="sm"
        disabled={disabled || entryGuids.length === 0}
        onClick={() => onShareClick(entryGuids)}
      >
        <FontAwesomeIcon icon={faShareAlt} className="me-2" />
        Share with organization
      </Button>
    </div>
  );
};

JournalBulkActions.propTypes = {
  table: PropTypes.bool,
  selectedRowIds: PropTypes.object,
  page: PropTypes.array,
  onShareClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

JournalBulkActions.defaultProps = {
  selectedRowIds: {},
  page: [],
  disabled: false
};

export default JournalBulkActions;
